import React from "react";
import { GroupsList } from "./GroupsList/GroupsList";

export const GroupsContent = () => {
  return (
    <div className="d-flex flex-column gap-1 mt-5 GroupsContent">
      <GroupsList />
    </div>
  );
};
